import AutomateMessageEdit from "../components/page/AutomateMessageEdit";

const AutomateMessageEditPage = () => {
  return (
      <AutomateMessageEdit />
  );
};
export default AutomateMessageEditPage;
